import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { motion } from "framer-motion";

import { Submit } from "../../Components/Button";
import * as actionTypes from "../../redux/actionTypes";
import { ThemeContext } from "../../helper/DarkModeContext";

const MappingMode = ({ match: { params } }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const TB_ID = useSelector((initialState) => initialState.reducer.tb_id);
  const [click, setClick] = useState();
  console.log(TB_ID, "1111111111111111111111111111111111");
  const project_id = localStorage.getItem("project_id");
  const auth = localStorage.getItem("auth_token");
  const { theme } = useContext(ThemeContext);
  let headers = {
    "x-auth-token": auth,
    // 'Content-Type' : 'application/json'
  };

  console.log(params, "mapping mode");
  function handleSelect(name) {
    console.log(name, '"nae"');
    setClick(name);
  }

  function eliminateDupe(data) {
    // console.log(data,'elimination loop --------------------------------------- elimination loop')
    let line_items = [];
    const list = data.reverse();
    // console.log(list,'list no reverse dupe here elimination loop --------------------------------------- elimination loop')
    list.map((line, i) => {
      // if (line_items.length < 1) {
      //   line_items.push(line);
      //   return;
      // }
      // if (line.ledger_code) {
      //   if (
      //     line_items.some(
      //       (user) =>
      //         user.ledger_code === line.ledger_code &&
      //         user.branch === line.branch
      //     )
      //   ) {
      //     return;
      //   }
      // }
      // // if(line_items.some(user => user.ledger_code === line.ledger_code)){
      // if (
      //   line_items.some(
      //     (user) =>
      //       user.ledger_name === line.ledger_name && user.branch === line.branch
      //   )
      // ) {
      //   return;
      // }
      line_items.push(line);
    });

    console.log(line_items);

    const replace_tb = line_items.reverse();
    const new_tb = JSON.stringify(replace_tb);
    const fd = new FormData();
    fd.append("tb", new_tb);
    axios
      .post(`api/v1/project/replace-tb/${project_id}/${TB_ID}`, fd, { headers })
      .then((res) => {
        console.log(res, "response for ");
        dispatch({ type: actionTypes.SET_TABLE_DATA, payload: replace_tb });
      })
      .catch((err) => {
        console.log(err.response, "response error");
      });
  }

  function populateTable() {
    console.log("hello");
    axios
      .get(`api/v1/tb-mapping/conventional-mode/${project_id}/${TB_ID}`, {
        headers,
      })
      .then((response) => {
        console.log(response.data, "response after tb upload");
        axios
          .get(`api/v1/conventional-mode/fetch/${project_id}/${TB_ID}`, {
            headers,
          })
          .then((response) => {
            eliminateDupe(response.data.data.line_items);
            // dispatch({
            //   type: actionTypes.SET_TABLE_DATA,
            //   payload: response.data.data.line_items,
            // });
            console.log(
              response.data,
              "dat dat dat datd ddat dat dat dat dat dta dat d"
            );

            if (click === "1") {
              history.push(`/Conventional/${params.pid}`);
            }
            if (click === "2") {
              history.push(`/templateV2/${params.pid}`);
            }
            // history.push(`/conventional/${params.pid}`)
          });
      })
      .catch((error) => {
        console.log(error.response, "error");

        if (
          error.response.data.error ===
          "Not able to fetch data, Project File Corrupted"
        ) {
          if (click === "1") {
            history.push(`/Conventional/${params.pid}`);
          }
          if (click === "2") {
            history.push(`/templateV2/${params.pid}`);
          }
        }
      });
  }

  return (
    <>
    <div className="row" style={{marginRight:"0px"}}>
      <div className="col-4">
        <div
          className="track"
          style={{
            background: `${theme ? "" : "#363535"}`,
            color: `${theme ? "" : "#fff"}`,
          }}
        >
          <div className="progressBar">
            <div className="vector-3"></div>
            <div className="progressRoute">
              <div className="track1">
                <h4>Project Creation</h4>
                <p>
                  Fill basic details for creating <br />a project
                </p>
              </div>
              <div className="track1">
                <h4>File Upload</h4>
                <p>
                  Upload individual or multiple <br />
                  trial balance
                </p>
              </div>
              <div className="track1">
                <h4>Data Mapping</h4>
                <p>
                  Map general ledgers to financial <br />
                  statement
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-8 main">
        <div className="modeHeader">
          <h1>Choose a mapping mode</h1>
          <p>This step is important to map the trial balance ledger</p>
          <p>to Financial Statement</p>
        </div>
        <div className="cMode">
          <motion.div
            className={click === "1" ? "modeImg-1_active" : "modeImg-1"}
            onClick={() => handleSelect("1")}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.1 },
            }}
          ></motion.div>
          <div className="modeContent">
            <h1>Conventional Mode</h1>
            <p>
              This mode allows you to assign individual ledgers
              <br />
              to respective financial statements, and their notes
            </p>
          </div>
        </div>
        <div className="tMode">
          <motion.div
            className={click === "2" ? "modeImg-2_active" : "modeImg-2"}
            onClick={() => handleSelect("2")}
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.1 },
            }}
          ></motion.div>
          <div className="modeContent">
            <h1>Template Mode--</h1>
            <p>
              This mode allows you to assign one or more <br />
              ledgers to a given FS template, and all you have to
              <br />
              do is drag and drop the ledgers.
            </p>
          </div>
        </div>

        <div
          className="post"
          onClick={() => {
            populateTable();
          }}
        >
          {(click === null) | (click === "") ? (
            <Submit disable value="Proceed" />
          ) : (
            <Submit value="Proceed" />
          )}
        </div>

      </div>
    </div>
  
    </>
  );
};

export default MappingMode;
